// extracted by mini-css-extract-plugin
export default {"playerName":"styles_playerName__d8KNT","name":"styles_name__cDkaY"};